<template>
  <div ref="scroller"
       class="mod-touch-map">
    <div ref="map"
         class="map">
      <div v-for="(item, index) in bgs"
           :key="index"
           :style="item"
           class="bg"></div>
      <bubble-talk v-for="(item, index) in talks"
                   :key="'talk' + index"
                   :meta="item" />
      <div v-for="(item, index) in objs"
           :key="'obj' + index"
           :style="getStyle(item)"
           class="item"
           :class="{active: treasure_nums[item.num]}"
           @click="tapChest(item.num)">
        <!-- {{item.num}} -->
      </div>
    </div>
  </div>
</template>

<script>
import Scroller from '@/utils/zscroller'
import BubbleTalk from '@/components/bubble-talk'
import { px2rem } from '@/utils'
export default {
  components: {
    BubbleTalk
  },
  props: {
    treasure_nums: Object
  },
  data() {
    return {
      text: '',
      sizeMap: [],
      bgs: [
        {
          left: 0,
          width: px2rem(1900),
          height: px2rem(4148),
          backgroundImage: `url('${require('@/assets/index/bg-1.jpg')}')`
        },
        {
          left: px2rem(1900),
          width: px2rem(1900),
          height: px2rem(4148),
          backgroundImage: `url('${require('@/assets/index/bg-2.jpg')}')`
        },
        {
          left: px2rem(3800),
          width: px2rem(1900),
          height: px2rem(4148),
          backgroundImage: `url('${require('@/assets/index/bg-3.jpg')}')`
        }
      ],
      talks: [
        {
          num: 1,
          x: 3100,
          y: 1920,
          text: '恭喜你找到啦！\n滑动页面可以看到更广阔的城市，\n擦亮眼睛继续寻找吧！',
          pos: 'right'
        },
        {
          num: 2,
          x: 3600,
          y: 1740,
          text: '投资的钱赎回得下周一才到账，下次我再请。',
          pos: 'left'
        },
        {
          num: 2,
          x: 3624,
          y: 1800,
          text: '扫我吧！零花钱放在天天成长2号，\n消费免赎回，能赚又能花。',
          pos: 'left'
        },
        {
          num: 3,
          x: 4260,
          y: 2280,
          text: '人退休了，投资可不能退休！\n小安有啥推荐？',
          pos: 'top'
        },
        {
          num: 3,
          x: 3940,
          y: 2530,
          text: '您说的对！关注新卓越，收获时间带来的价值空间。',
          pos: 'bottom'
        },
        {
          num: 4,
          x: 4310,
          y: 3010,
          text: '小安，你想成为什么样的投资经理？',
          pos: 'top'
        },
        {
          num: 4,
          x: 4040,
          y: 3250,
          text: '“受人之托 代客理财”是我的初心，希望我的\n专业陪伴能带给您稳稳的幸福。',
          pos: 'bottom'
        },
        {
          num: 5,
          x: 3840,
          y: 3540,
          text: '绿码守护健康，平安理财守护钱袋子。',
          pos: 'right'
        },
        {
          num: 6,
          x: 1210,
          y: 3560,
          text: '精彩的人生源于从容选择，\n启航选择稳健策略，\n带给我稳稳的幸福。\n出发吧！船长。',
          pos: 'right'
        },
        {
          num: 7,
          x: 1340,
          y: 480,
          text: '投资在于长期坚持，\n才能迎来花开时刻。',
          pos: 'right'
        },
        {
          num: 8,
          x: 530,
          y: 950,
          text: '飞机能带你遨游世界，\n我的鑫享Gmat，能带你\n参与配置全球大类资产！',
          pos: 'right'
        },
        {
          num: 9,
          x: 4300,
          y: 1690,
          text: '每月投资一点，\n离奶茶自由更进一步',
          pos: 'right'
        },
        {
          num: 10,
          x: 1330,
          y: 2600,
          text: '固收+就像汉堡，面包胚管饱，\n是打底资产，牛肉提升“口感”\n力争增厚收益。',
          pos: 'right'
        },
        {
          num: 11,
          x: 2400,
          y: 3236,
          text: '平安理财马上一周岁啦！我的目标\n是成长为“科技型资产管理机构”\n和“全品类开放式理财平台”。',
          pos: 'right'
        },
        {
          num: 12,
          x: 240,
          y: 1790,
          text: '启航，80%以上主投固定收益类资产，\n握住稳稳的幸福',
          pos: 'right'
        },
        {
          num: 13,
          x: 940,
          y: 2700,
          text: '天天成长2号，7*24小时消费支付陪伴',
          pos: 'right'
        },
        {
          num: 14,
          x: 4900,
          y: 1596,
          text: '鑫享Gmat，布局全球大类资产',
          pos: 'left'
        },
        {
          num: 15,
          x: 4350,
          y: 160,
          text: '绝对收益目标+收益弹性空间，追求卓越是我们的方向',
          pos: 'top'
        },
        {
          num: 16,
          x: 1600,
          y: 210,
          text: '这都被你找到啦！',
          pos: 'right'
        },
        {
          num: 17,
          x: 850,
          y: 1460,
          text: '这都被你找到啦！',
          pos: 'right'
        },
        {
          num: 18,
          x: 1070,
          y: 2020,
          text: '分散投资，不要把鸡蛋放一个篮子里。',
          pos: 'right'
        },
        {
          num: 19,
          x: 955,
          y: 3350,
          text: '复利投资是通往财务自由的“垫脚石”。',
          pos: 'right'
        },
        {
          num: 20,
          x: 1785,
          y: 3540,
          text: '好一个火眼金睛！',
          pos: 'right'
        },
        {
          num: 21,
          x: 2600,
          y: 3200,
          text: '好一个火眼金睛！',
          pos: 'right'
        },
        {
          num: 22,
          x: 1985,
          y: 2960,
          text: '市场存在波动，\n长期持有是应对利器。',
          pos: 'right'
        },
        {
          num: 23,
          x: 2850,
          y: 2040,
          text: '财富在于日常积累，钱是理出来的。',
          pos: 'right'
        },
        {
          num: 24,
          x: 2130,
          y: 1640,
          text: '诶呀，被发现了！',
          pos: 'right'
        },
        {
          num: 25,
          x: 2890,
          y: 1150,
          text: '长期型理财能克服追涨杀跌的心理。',
          pos: 'right'
        },
        {
          num: 26,
          x: 1570,
          y: 1230,
          text: '学会理财，告别月光。',
          pos: 'right'
        },
        {
          num: 27,
          x: 3550,
          y: 930,
          text: '诶呀，被发现了！',
          pos: 'right'
        },
        {
          num: 28,
          x: 4105,
          y: 2360,
          text: '稳健策略理财\n带给生活满满的安全感',
          pos: 'right'
        },
        {
          num: 29,
          x: 3850,
          y: 2750,
          text: '绿码守护健康\n平安理财守护钱袋子。',
          pos: 'right'
        },
        {
          num: 30,
          x: 4750,
          y: 2950,
          text: '优中选优结构理财\n让未来更笃定',
          pos: 'right'
        },
        {
          num: 31,
          x: 410,
          y: 3760,
          text: '卓越系列，稳当下利长远',
          pos: 'right'
        },
        {
          num: 32,
          x: 5050,
          y: 3700,
          text: '理财选安鑫，投资更安心',
          pos: 'top'
        },
        {
          num: 33,
          x: 5110,
          y: 2970,
          text: '团队强守护，安鑫享未来',
          pos: 'left'
        },
        {
          num: 34,
          x: 1930,
          y: 2210,
          text: '平安理财，一路相伴，\n为更好的人生增添底气',
          pos: 'right'
        },
        {
          num: 35,
          x: 3120,
          y: 1490,
          text: '平安理财，专业 让生活更简单',
          pos: 'right'
        },
        {
          num: 36,
          x: 3000,
          y: 3170,
          text: '生活不只是漂泊不定，\n还有稳健策略带来的安全感',
          pos: 'top'
        },
        {
          num: 37,
          x: 4200,
          y: 1540,
          text: '生活不只是精打细算\n还有灵活安排营造的仪式感',
          pos: 'right'
        },
        {
          num: 38,
          x: 2220,
          y: 1000,
          text: '生活不只是精打细算\n还有灵活安排营造的仪式感',
          pos: 'right'
        },
        {
          num: 39,
          x: 2500,
          y: 1010,
          text: '做有温度的金融，\n专业用心守护你的钱袋子。',
          pos: 'right'
        }
      ],
      objs: [
        {
          num: 1,
          x: 3020,
          y: 1920,
          width: 70,
          height: 140
        },
        {
          num: 2,
          x: 4100,
          y: 1800,
          width: 70,
          height: 140
        },
        {
          num: 3,
          x: 4240,
          y: 2380,
          width: 70,
          height: 140
        },
        {
          num: 4,
          x: 4290,
          y: 3100,
          width: 70,
          height: 140
        },
        {
          num: 5,
          x: 3760,
          y: 3540,
          width: 70,
          height: 140
        },
        {
          num: 6,
          x: 1130,
          y: 3560,
          width: 70,
          height: 140
        },
        {
          num: 7,
          x: 1270,
          y: 486,
          width: 50,
          height: 50
        },
        {
          num: 8,
          x: 450,
          y: 950,
          width: 70,
          height: 140
        },
        {
          num: 9,
          x: 4240,
          y: 1690,
          width: 50,
          height: 50
        },
        {
          num: 10,
          x: 1250,
          y: 2600,
          width: 70,
          height: 140
        },
        {
          num: 11,
          x: 2320,
          y: 3236,
          width: 70,
          height: 140
        },
        {
          num: 12,
          x: 0,
          y: 1770,
          width: 230,
          height: 380
        },
        {
          num: 13,
          x: 680,
          y: 2640,
          width: 240,
          height: 370
        },
        {
          num: 14,
          x: 5328,
          y: 1576,
          width: 254,
          height: 370
        },
        {
          num: 15,
          x: 4570,
          y: 250,
          width: 264,
          height: 370
        },
        {
          num: 16,
          x: 1530,
          y: 210,
          width: 50,
          height: 50
        },
        {
          num: 17,
          x: 790,
          y: 1460,
          width: 50,
          height: 50
        },
        {
          num: 18,
          x: 1010,
          y: 2020,
          width: 50,
          height: 50
        },
        {
          num: 19,
          x: 895,
          y: 3350,
          width: 50,
          height: 50
        },
        {
          num: 20,
          x: 1725,
          y: 3540,
          width: 50,
          height: 50
        },
        {
          num: 21,
          x: 2540,
          y: 3200,
          width: 50,
          height: 50
        },
        {
          num: 22,
          x: 1925,
          y: 2960,
          width: 50,
          height: 50
        },
        {
          num: 23,
          x: 2790,
          y: 2040,
          width: 50,
          height: 50
        },
        {
          num: 24,
          x: 2070,
          y: 1640,
          width: 50,
          height: 50
        },
        {
          num: 25,
          x: 2830,
          y: 1150,
          width: 50,
          height: 50
        },
        {
          num: 26,
          x: 1510,
          y: 1230,
          width: 50,
          height: 50
        },
        {
          num: 27,
          x: 3490,
          y: 930,
          width: 50,
          height: 50
        },
        {
          num: 28,
          x: 4045,
          y: 2360,
          width: 50,
          height: 50
        },
        {
          num: 29,
          x: 3790,
          y: 2750,
          width: 50,
          height: 50
        },
        {
          num: 30,
          x: 4680,
          y: 2950,
          width: 50,
          height: 50
        },
        {
          num: 31,
          x: 160,
          y: 3700,
          width: 230,
          height: 370
        },
        {
          num: 32,
          x: 5100,
          y: 3780,
          width: 230,
          height: 360
        },
        {
          num: 33,
          x: 5460,
          y: 2930,
          width: 230,
          height: 370
        },
        // logo
        {
          num: 34,
          x: 1830,
          y: 2210,
          width: 100,
          height: 80
        },
        {
          num: 35,
          x: 3020,
          y: 1460,
          width: 100,
          height: 110
        },
        {
          num: 36,
          x: 3120,
          y: 3290,
          width: 100,
          height: 80
        },
        {
          num: 37,
          x: 4100,
          y: 1550,
          width: 100,
          height: 80
        },
        {
          num: 38,
          x: 2130,
          y: 1000,
          width: 100,
          height: 80
        },
        {
          num: 39,
          x: 2420,
          y: 1010,
          width: 70,
          height: 140
        }
      ]
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      const map = this.$refs.map
      const style = getComputedStyle(map)
      const height = style.height.replace('px', '') * 1
      const width = style.width.replace('px', '') * 1
      const winHeight = window.innerHeight
      const winWidth = window.innerWidth
      const container = this.$refs.scroller
      const render = function () {
        const docStyle = document.documentElement.style

        let engine
        if (window.opera && Object.prototype.toString.call(window.opera) === '[object Opera]') {
          engine = 'presto'
        } else if ('MozAppearance' in docStyle) {
          engine = 'gecko'
        } else if ('WebkitAppearance' in docStyle) {
          engine = 'webkit'
        } else if (typeof navigator.cpuClass === 'string') {
          engine = 'trident'
        }

        const vendorPrefix = {
          trident: 'ms',
          gecko: 'Moz',
          webkit: 'Webkit',
          presto: 'O'
        }[engine]

        const helperElem = document.createElement('div')
        let undef

        const perspectiveProperty = vendorPrefix + 'Perspective'
        const transformProperty = vendorPrefix + 'Transform'

        if (helperElem.style[perspectiveProperty] !== undef) {
          return function (left, top, zoom) {
            map.style[transformProperty] = 'translate3d(' + (-left) + 'px,' + (-top) + 'px,0) scale(' + zoom + ')'
          }
        } else if (helperElem.style[transformProperty] !== undef) {
          return function (left, top, zoom) {
            map.style[transformProperty] = 'translate(' + (-left) + 'px,' + (-top) + 'px) scale(' + zoom + ')'
          }
        } else {
          return function (left, top, zoom) {
            map.style.marginLeft = left ? (-left / zoom) + 'px' : ''
            map.style.marginTop = top ? (-top / zoom) + 'px' : ''
            map.style.zoom = zoom || ''
          }
        }
      }

      const scroller = new Scroller(render(), {
        bouncing: false
      })
      scroller.setPosition(0, 0)
      scroller.setDimensions(winWidth, winHeight, width, height)
      container.addEventListener('touchstart', function (e) {
        scroller.doTouchStart(e.touches, e.timeStamp)
      }, false)
      container.addEventListener('touchmove', (e) => {
        scroller.doTouchMove(e.touches, e.timeStamp, e.scale)
        this.$event.emit('Hide_All')
        e.preventDefault()
      }, false)
      container.addEventListener('touchend', function (e) {
        scroller.doTouchEnd(e.timeStamp)
      }, false)
      container.addEventListener('touchcancel', function (e) {
        scroller.doTouchEnd(e.timeStamp)
      }, false)
      // scroller.scrollTo(300, 300)
      // 转换相对
      const left = (width - winWidth) / 2 + 180
      const top = (height - winHeight) / 2 - 110
      scroller.scrollTo(left, top)
    },
    getStyle(pos) {
      return {
        top: px2rem(pos.y),
        left: px2rem(pos.x),
        width: px2rem(pos.width),
        height: px2rem(pos.height)
      }
    },
    tapChest(num) {
      console.debug('点击宝物', num)
      this.$event.emit('Open', num)
      this.$emit('chest', num)
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-touch-map {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .map {
    position: relative;
    width: 5700px;
    height: 4148px;
    // width: 8102px;
    // height: 5895px;
    touch-action: none;
    will-change: transform;
    .bg {
      position: absolute;
      top: 0;
      background-size: 100% auto;
      background-repeat: no-repeat;
      z-index: -1;
    }
    .item {
      position: absolute;
      font-size: 24px;
      color: rgba($color: #fff, $alpha: 0.9);
      z-index: 20;
      opacity: 0;
      &.active {
        transform: scale(1.2);
        opacity: 1;
        z-index: 1;
        background-position: right bottom;
        background-image: url(data:image/png;base64,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);
        background-repeat: no-repeat;
        background-size: 80% auto;
      }
    }
  }
}
</style>